import React from 'react';

import { useCurrentTheme } from 'app/shared/theme';
import { OnSignUpSuccess } from 'app/shared/typings';
import { useAuthFormContext } from 'app/shared/context';
import { Box } from 'app/shared/components/atoms';
import { AlternativesDivider } from 'app/shared/components/molecules';

import { AppleLoginButton } from './AppleLoginButton';
import { FacebookLoginButton } from './FacebookLoginButton';
import { GoogleLoginButton } from './GoogleLoginButton';
import { ThirdPartyAuthMode } from './ThirdPartyAuthButton';

export { ThirdPartyAuthMode };

export const ThirdPartyAuth = ({
  testMode,
  testResponse,
  ...props
}: {
  mode: ThirdPartyAuthMode;
  onSuccess: OnSignUpSuccess;
  onError?: (e: any) => void;
  testMode?: boolean;
  testResponse?: any;
}) => {
  const { isCompleteSignUpFlow } = useAuthFormContext();
  const { colors } = useCurrentTheme();

  if (isCompleteSignUpFlow || (testMode && !testResponse)) {
    return null;
  }

  return (
    <>
      <AlternativesDivider
        color={colors.primary.black.base}
        textColor={colors.primary.black.base}
        backgroundColor={colors.primary.white.base}
      />
      <Box gap={2} flexDirection="column">
        <AppleLoginButton {...props} />
        {process.env.GOOGLE_CLIENT_ID && <GoogleLoginButton {...props} />}
        <FacebookLoginButton
          {...props}
          testMode={testMode}
          testResponse={testResponse}
        />
      </Box>
    </>
  );
};
